export let LineMarkerType;(function(e){e["ARROW"]="ARROW"})(LineMarkerType||(LineMarkerType={}));